import { ForgotPasswordForm } from "../components/forgot-password-form";

export const ForgotPasswordPage: React.FC = () => {
  return <ForgotPasswordForm />;
};
